<template>
  <v-dialog v-model="dialog" max-width="400" @click:outside="close">
    <v-card>
      <v-card-title class="pt-4">{{ createOrUpdate }} revision</v-card-title>
      <v-card-text class="pl-4 pt-0">
        <FormRHDHV
          ref="form"
          :url="strippedUrl"
          :model="model"
          :formOrder="fields"
          :dialog="dialog"
        />
        <v-select
          class="my-4"
          label="Duplicate from"
          v-model="duplicatedRevisionId"
          :items="revisionSet"
          item-title="name"
          item-value="id"
          hide-details
          persistent-hint
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" color="primary" text @click="save()"> Save </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import FormRHDHV from '@/components/form/FormRHDHV.vue'

export default {
  name: 'RevisionDialog',
  components: { FormRHDHV },
  props: {
    storeNamespace: {
      required: true
    },
    parameter: {
      required: true
    },
    allowNoRevision: {
      default: false,
      required: false
    }
  },
  data: () => ({
    model: null,
    duplicatedRevisionId: null,
    loading: false
  }),
  computed: {
    ...mapState('project', {
      currentProject: (state) => state.currentProject
    }),
    ...mapGetters('project', {
      parameterSetName: 'parameterSetName'
    }),
    baseRevision() {
      return this.$store.state[this.storeNamespace]['baseRevision']
    },
    dialog() {
      return this.$store.state[this.storeNamespace]['dialog']
    },
    selectedRevision() {
      return this.$store.state[this.storeNamespace]['selectedRevision']
    },
    createOrUpdate() {
      return 'Create'
    },
    revisionSet() {
      const parameterSetName = this.parameterSetName(this.parameter)
      const revisionSet = this.currentProject[parameterSetName]
      if (this.allowNoRevision) {
        return [
          {
            id: null,
            name: '-----'
          },
          ...revisionSet
        ]
      }
      return revisionSet
    },
    fields() {
      return this.$store.state[this.storeNamespace]['fields']
    },
    strippedUrl() {
      const baseUrl = this.$store.state[this.storeNamespace]['baseUrl']
      return baseUrl.replaceAll('/', '')
    }
  },
  watch: {
    dialog() {
      // Required otherwise the form will throw validation errors
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    selectedRevision() {
      this.duplicatedRevisionId = this.selectedRevision?.id || null
    }
  },
  methods: {
    close() {
      this.$refs.form.resetValidation()
      this.$store.dispatch(this.storeNamespace + '/toggleRevisionDialog')
    },
    async save() {
      this.loading = true
      let is_valid = this.$refs.form.save()
      this.model.project = this.currentProject.id
      if (is_valid) {
        try {
          const requestData = {
            ...this.model,
            selected_revision: this.duplicatedRevisionId
          }
          await this.$store.dispatch(this.storeNamespace + '/createRevision', {
            parameter: this.parameter,
            payload: requestData
          })
          this.close()
          this.model = JSON.parse(JSON.stringify(this.baseRevision))
        } catch (error) {
          this.loading = false
          console.log(error)
        } finally {
          this.loading = false
        }
      } else {
        console.log('Is not valid')
      }
    }
  },
  async mounted() {
    this.duplicatedRevisionId = this.selectedRevision?.id || null
    this.model = JSON.parse(JSON.stringify(this.baseRevision))
  }
}
</script>
